import useOnMount from "./useOnMount";

const useSideNavClickListener = () => {
  useOnMount(() => {
    // Empty handler to prevent default collapse behavior
    const handler = () => {};

    window.addEventListener("click", handler, true);

    return () => {
      window.removeEventListener("click", handler, true);
    };
  });
};

export default useSideNavClickListener;
